<template>
  <div>
    <div
      :class="['upload', uploadComplete ? 'uploadComplete' : '']"
      @click="upload"
      id="drop-area"
      @dragover.prevent
      @drop.prevent="handleDrop"
      @dragenter="highlight"
      @dragleave="unhighlight"
    >
      <div class="up-model ">
        <div>
          <p><img src="@/assets/icons/icon_upload@2x.png" alt="" class="up-icon" /></p>
          <div>
            <p v-if="uploadComplete" style="font-weight: bold;">
              点击 <span style="color: #FF6D00; ">上传文件按钮</span> 或 可将
              <span style="color: #000;">文件拖拽</span> 到这里上传
            </p>
            <p v-else>请将文件拖拽到这里上传</p>
            <p class="tips">单次最多可上传{{ maxFileCount }}个文件，单个文件不超过{{ maxFileSize / 1024 / 1024 }}MB</p>
          </div>
        </div>
        <a-button type="primary" style="margin-top: 30px;">
          <img src="@/assets/icons/icon_scb@2x.png" style="width: 20px; padding-right: 8px; margin-top: -3px" />
          选择文件
        </a-button>
      </div>
      <input ref="fileInput" type="file" multiple :accept="accept" style="display: none;" @change="inputChange" />
    </div>
    <div class="tip">
      <span>支持的文件类型:</span>
      <a-tooltip placement="topLeft" v-for="item in tipList" :key="item.desc" :arrowPointAtCenter="true">
        <template slot="title">
          <span>{{ item.desc }}</span>
        </template>
        <img :src="item.img" alt="" class="list" />
      </a-tooltip>
      <span>{{ item }}</span>
    </div>
    <!-- <FailureDetails ref="FailureDetails" :data="failFileList" @changeMassUploadvisible="changeMassUploadvisible" /> -->
    <canvas ref="canvas" style="display:none;"></canvas>
    <!-- 文件列表 -->
    <div class="file-list">
      <div
        class="file-item"
        v-for="(item, index) in fileList"
        :key="index"
        :style="{ '--progress': item.progress + '%' }"
        :data-progress="item.progress"
      >
        <div class="file-icon">
          <img :src="item.icon" alt="" />
        </div>
        <div style="flex: 1">
          <div class="file-name">
            <span v-if="!item.editing">{{ item.name }}</span>
            <div v-else class="edit-filename">
              <a-input
                style="width: 400px;"
                maxLength="30"
                v-model="editingFileName"
                @pressEnter="saveFileName(index)"
                @blur="saveFileName(index)"
                :default-value="getFileNameWithoutExt(item.name)"
                :rules="[{ required: true, message: '文件名不能为空' }]"
              />
              <span class="file-ext">.{{ getFileExt(item.name) }}</span>
            </div>
          </div>
          <div class="file-size">{{ item.size }}</div>
        </div>
        <div class="file-actions">
          <a-button type="link" icon="edit" @click="editFileName(index)" v-if="!item.editing" />
          <img
            src="@/assets/icons/icon_sc.png"
            alt=""
            srcset=""
            style="width: 15px; cursor: pointer; margin-left: 5px; margin-top: -2px;"
            @click=";(deleteFileInx = index), (delVisible = true)"
          />
        </div>
      </div>
    </div>
    <TipModal
      @ok="deleteFile"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>确定要删除？</p>
        <p class='placeholder'>确认删除后无法恢复</p>`
      "
    />
    <!-- 添加重复文件确认弹窗 -->
    <a-modal
      title="文件名称重复提示"
      :visible="duplicateVisible"
      @ok="handleDuplicateConfirm"
      @cancel="handleDuplicateCancel"
      okText="覆盖上传"
      cancelText="取消"
      width="500px"
    >
      <div class="duplicate-modal-content">
        <div class="duplicate-warning">
          <a-icon type="warning" theme="filled" style="color: #faad14; font-size: 22px; margin-right: 10px;" />
          <span>检测到以下文件名称与知识库中已有文件重复，是否覆盖原文件？</span>
        </div>
        <div class="duplicate-file-list">
          <div v-for="(fileName, index) in duplicateFileNames" :key="index" class="duplicate-file-item">
            <a-icon type="file" style="margin-right: 8px;" />
            <span>{{ fileName }}</span>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
// import FailureDetails from './FailureDetails.vue'
import { batchUpload } from '@/api/lesson'
import TipModal from '@/components/tipModal/index.vue'
import SparkMD5 from 'spark-md5'
import { checkFileName } from '@/api/ai.js'

export default {
  name: 'MassUpload',
  components: {
    TipModal
  },
  data() {
    return {
      maxFileCount: 5, // 最大文件数量限制
      maxFileSize: 15 * 1024 * 1024, // 最大文件大小限制（100MB）
      visible: false,
      fileList: [],
      successNum: 0,
      uploadStaus: {
        ok: false,
        fail: false,
        ing: false,
        end: false,
        progress: 0,
        isUploading: true
      },
      isHighlighted: false,
      failFileList: [],
      batchFileList: [],
      accept: '.docx,.xls,.xlsx,.pdf,.txt',
      acceptArr: ['docx', 'xls', 'xlsx', 'pdf', 'txt'],
      tipList: [
        {
          img: require('@/assets/icons/icon_pdf.png'),
          desc: 'pdf'
        },
        {
          img: require('@/assets/icons/icon_word.png'),
          desc: 'docx'
        },
        {
          img: require('@/assets/icons/icon_xlsx.png'),
          desc: 'xlsx、xls'
        },
        {
          img: require('@/assets/icons/icon_t@2x.png'),
          desc: 'txt'
        }
      ],
      uploadComplete: false,
      delVisible: false,
      duplicateFileNames: [],
      duplicateVisible: false,
      editingFileName: ''
    }
  },
  methods: {
    showModal() {
      this.initData()
    },
    handleOk() {
      this.uploadStaus.ing = false
      this.uploadStaus.isUploading = false
      this.$emit('hideVisible')
    },
    initData() {
      this.successNum = 0
      this.uploadStaus.ok = false
      this.uploadStaus.fail = false
      this.fileList = []
      this.batchFileList = []
      this.uploadStaus.end = false
      this.uploadStaus.progress = 0
      this.uploadStaus.isUploading = true
    },
    upload() {
      this.$refs.fileInput.click()
    },
    inputChange(e, files) {
      console.log('e, files ----->', e, files)
      const _this = this
      const resourceMap = {
        doc: '文本类',
        docx: '文本类',
        xls: '文本类',
        xlsx: '文本类',
        pdf: '文本类',
        ppt: '文本类',
        pptx: '文本类',
        txt: '文本类',
        md: '文本类',
        csv: '文本类'
      }
      function getFileExtension(filename) {
        const match = filename.match(/\.([^.]+)$/)
        return match ? match[1].toLowerCase() : null
      }
      function setTips(file, msg = '文件过大，上传失败') {
        file.flag = false
        file.msg = msg
        _this.uploadStaus.fail = true
      }
      this.uploadStaus.ing = true

      // 获取新文件列表并转换为数组
      const newFiles = Array.from(!e ? files : e.target.files)

      // 检查文件大小限制
      const validFiles = newFiles.filter(file => {
        if (file.size > this.maxFileSize) {
          this.$message.error(`文件 ${file.name} 超过${this.maxFileSize / 1024 / 1024}MB限制，已自动过滤`)
          return false
        }
        return true
      })

      // 检查文件总数限制
      if (this.fileList.length + validFiles.length > this.maxFileCount) {
        this.$message.error(`文件总数不能超过${this.maxFileCount}个，超出部分已自动过滤`)
        validFiles.splice(this.maxFileCount - this.fileList.length)
      }

      // 转换为所需格式
      const processedFiles = validFiles.map(item => ({
        name: item.name,
        size: '',
        type: '文档',
        icon: '',
        editing: false,
        file: item
      }))

      // 合并新旧文件列表
      this.fileList = [...this.fileList, ...processedFiles]

      console.log('this.fileList ----->', this.fileList)
      if (this.fileList.length === 0 || !this.uploadStaus.isUploading) return

      this.fileList.forEach((file, inx) => {
        if (!resourceMap[getFileExtension(file.name)]) {
          setTips(file, '暂不支持上传该类资源')
        }
      })
      console.log('end----->')
      this.packetUpload()
    },
    failureDetails() {
      this.changeMassUploadvisible(false)
      this.$refs.FailureDetails.visible = true
    },
    changeMassUploadvisible(visible) {
      this.$emit('changeMassUploadvisible', visible)
    },
    highlight() {
      this.isHighlighted = true
    },
    unhighlight() {
      this.isHighlighted = false
    },
    async handleDrop(event) {
      const files = []
      let oneFiles = []
      const readDirectory = directoryEntry => {
        return new Promise(resolve => {
          const dirReader = directoryEntry.createReader()
          dirReader.readEntries(async entries => {
            for (const entry of entries) {
              if (entry.isFile) {
                const file = await new Promise(resolve => {
                  entry.file(resolve)
                })
                // 添加文件格式验证
                const ext = file.name
                  .split('.')
                  .pop()
                  .toLowerCase()
                if (this.accept.includes(`.${ext}`)) {
                  files.push(file)
                }
              } else if (entry.isDirectory) {
                await readDirectory(entry)
              }
            }
            resolve()
          })
        })
      }

      const items = event.dataTransfer.items
      const promises = []
      for (let i = 0; i < items.length; i++) {
        const item = items[i].webkitGetAsEntry()
        if (item.isFile) {
          await new Promise(resolve => {
            oneFiles = [...event.dataTransfer.files]
              .filter(file => {
                // 添加文件格式验证
                const ext = file.name
                  .split('.')
                  .pop()
                  .toLowerCase()
                return this.accept.includes(`.${ext}`)
              })
              .filter(file => {
                if (file.size > this.maxFileSize) {
                  this.$message.error(`文件 ${file.name} 超过${this.maxFileSize / 1024 / 1024}MB限制，已自动过滤`)
                  return false
                }
                return true
              })
            resolve('')
          })
        } else if (item.isDirectory) {
          promises.push(readDirectory(item))
        }
      }

      // 等待所有文件和文件夹都被读取
      Promise.all(promises).then(() => {
        const allFiles = [...oneFiles, ...files]
        // 检查总数限制
        if (this.fileList.length + allFiles.length > this.maxFileCount) {
          this.$message.error(`文件总数不能超过${this.maxFileCount}个，超出部分已自动过滤`)
          allFiles.splice(this.maxFileCount - this.fileList.length)
        }
        const filterFiles = allFiles.filter(file => {
          // 添加文件格式验证
          const ext = file.name
            .split('.')
            .pop()
            .toLowerCase()
          return this.acceptArr.includes(`${ext}`)
        })
        this.handleFiles({ target: { files: filterFiles } })
      })
    },
    handleFiles(event) {
      const files = event.target.files
      this.inputChange(null, files)
      // Array.from(files).forEach(this.uploadFile)
    },
    batchUploadFn(allSuccess) {
      if (this.batchFileList.length === 0) return
      batchUpload({ list: this.batchFileList }).then(res => {
        this.$emit('ok', allSuccess)
      })
    },
    stopBubbling(e) {
      console.log('e ----->', e)
      e.stopPropagation()
    },
    // 获取不带后缀的文件名
    getFileNameWithoutExt(filename) {
      return filename.substring(0, filename.lastIndexOf('.'))
    },

    // 获取文件后缀
    getFileExt(filename) {
      return filename.substring(filename.lastIndexOf('.') + 1)
    },

    // 修改编辑文件名方法
    editFileName(index) {
      this.$set(this.fileList[index], 'editing', true)
      this.editingFileName = this.getFileNameWithoutExt(this.fileList[index].name)
    },

    // 修改保存文件名方法
    saveFileName(index) {
      if (!this.editingFileName || this.editingFileName.trim() === '') {
        this.$message.error('文件名不能为空')
        return
      }

      const file = this.fileList[index]
      const newFileName = this.editingFileName + '.' + this.getFileExt(file.name)

      // 创建一个新的 File 对象来更新文件名
      const newFile = new File([file.file], newFileName, {
        type: file.file.type,
        lastModified: file.file.lastModified
      })

      file.name = newFileName
      file.file = newFile
      this.$set(this.fileList[index], 'editing', false)
      this.editingFileName = '' // 清空临时存储的文件名
    },
    deleteFile() {
      this.fileList.splice(this.deleteFileInx, 1)
      this.delVisible = false
    },
    // 计算文件的MD5值
    calculateFileMD5(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const buffer = e.target.result
          // 使用SparkMD5计算MD5
          const spark = new SparkMD5.ArrayBuffer()
          spark.append(buffer)
          const md5 = spark.end()
          file.md5 = md5 // 将MD5值添加到文件对象
          resolve(md5)
        }
        reader.onerror = e => {
          console.error('文件读取失败', e)
          reject(e)
        }
        reader.readAsArrayBuffer(file.file)
      })
    },
    handleCheckFileName() {
      const fileNameList = this.fileList.map(item => item.name)
      return new Promise((resolve, reject) => {
        checkFileName({
          datasetId: this.$route.query.id,
          name: fileNameList
        })
          .then(res => {
            if (res.code === 200) {
              if (res.data && res.data.list && res.data.list.length > 0) {
                // 过滤重复的文件名
                this.duplicateFileNames = res.data.list.map(item => item.name)

                // 为重复文件添加标识
                this.fileList.forEach(file => {
                  res.data.list.forEach(duplicateFile => {
                    if (duplicateFile.name === file.name) {
                      this.$set(file, 'isDuplicate', true)
                      this.$set(file, 'documentId', duplicateFile.id)
                    }
                  })
                })

                // 显示确认弹窗
                this.duplicateVisible = true
                resolve(false) // 返回 false 表示有重复文件
              } else {
                resolve(true) // 返回 true 表示没有重复文件
              }
            } else {
              reject(new Error('检查文件名失败'))
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    // 处理重复文件确认
    handleDuplicateConfirm() {
      this.overwriteConfirmed = true
      this.duplicateVisible = false
      // 继续上传流程
      this.continueUpload()
      this.$emit('SkipDetection')
    },

    // 处理重复文件取消
    handleDuplicateCancel() {
      this.duplicateVisible = false
      // 可以在这里添加取消后的逻辑，比如提示用户修改文件名
      this.$message.info('请修改重复的文件名后再上传')

      // 标记重复的文件，方便用户识别
      this.markDuplicateFiles()
    },

    // 标记重复的文件
    markDuplicateFiles() {
      this.fileList.forEach(file => {
        if (this.duplicateFileNames.includes(file.name)) {
          this.$set(file, 'duplicate', true)
          // 可以添加视觉提示，比如添加一个特殊的样式类
        }
      })
    },
    // 修改 packetUpload 方法，添加文件名检查
    async packetUpload() {
      // 先检查文件名是否重复
      try {
        // const noConflict = await this.handleCheckFileName()
        // if (!noConflict && !this.overwriteConfirmed) {
        //   return // 如果有冲突且用户未确认覆盖，则停止上传
        // }

        // // 重置覆盖确认状态，以便下次上传
        // this.overwriteConfirmed = false

        // 继续原来的上传逻辑
        this.continueUpload()
      } catch (err) {
        console.error('检查文件名失败:', err)
        this.$message.error('检查文件名失败，请重试')
      }
    },

    // 提取原 packetUpload 中的上传逻辑
    async continueUpload() {
      this.uploadComplete = true

      // 为每个文件生成MD5唯一值
      for (let i = 0; i < this.fileList.length; i++) {
        const file = this.fileList[i]
        // 读取文件内容并计算MD5
        await this.calculateFileMD5(file)
      }

      this.fileList.forEach((file, index) => {
        // 根据文件类型设置图标
        const fileType = file.name
          .split('.')
          .pop()
          .toLowerCase()
        const iconMap = {
          doc: require('@/assets/icons/icon_word.png'),
          docx: require('@/assets/icons/icon_word.png'),
          pdf: require('@/assets/icons/icon_pdf.png'),
          xls: require('@/assets/icons/icon_xlsx.png'),
          xlsx: require('@/assets/icons/icon_xlsx.png'),
          ppt: require('@/assets/icons/icon_ppt.png'),
          pptx: require('@/assets/icons/icon_ppt.png'),
          txt: require('@/assets/icons/icon_t@2x.png')
        }

        // 优化文件大小显示
        const fileSize = file.file.size
        let sizeDisplay
        if (fileSize < 1024) {
          sizeDisplay = fileSize + 'B'
        } else if (fileSize < 1024 * 1024) {
          sizeDisplay = (fileSize / 1024).toFixed(1) + 'KB'
        } else {
          const mbSize = fileSize / (1024 * 1024)
          if (mbSize < 0.01) {
            sizeDisplay = '0.01MB'
          } else {
            sizeDisplay = mbSize.toFixed(2) + 'MB'
          }
        }
        file.size = sizeDisplay
        file.type = '文档'
        file.icon = iconMap[fileType]
      })
      this.$emit('uploadData', this.fileList)
      this.$emit('ok')
    }

    // ... existing code ...
  }
}
</script>

<style lang="less" scoped>
.upload {
  height: 385px;
  flex-direction: column;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background: #fcfcfc;
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-icon {
    animation: rotate 1s linear infinite;
    width: 26px;
    margin-bottom: 11px;
  }
}
.tip {
  margin-top: 22px;
  color: #515e7b;
  font-weight: 400;
  font-size: 12px;
  .list {
    height: 21px;
    margin-left: 12px;
  }
}
.stopBubbling {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  margin-top: 10px;
  h4 {
    font-size: 16px;
    font-weight: bold;
  }
  .success-f-clolor {
    color: #258d64;
    font-weight: 540;
  }
  .cancel {
    position: absolute;
    right: 0px;
    top: 5px;
    color: #c1c1c1 !important;
  }
  .success {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #258d64;
    h4 {
      color: #258d64;
      margin: 11px 0 16px 0;
    }
    i {
      font-size: 28px;
    }
  }
  .warning {
    color: #ee453c;
    h4 {
      color: #ee453c;
    }
  }
  .error {
    color: #f5222d;
    h4 {
      color: #f5222d;
      font-weight: bold;
    }
  }
}
.up-model {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-weight: bold;
  > div {
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    > div {
      text-align: center;
    }
    > p {
      display: flex;
      justify-content: center;
      align-content: center;
    }
  }
  p {
    margin-bottom: 0px;
    color: #000;
    letter-spacing: 3px;
    img {
      margin-bottom: 15px;
    }
  }
  .up-icon {
    width: 105px;
    height: 86px;
  }
  .tips {
    font-size: 12px;
    color: #7281a4 !important;
    letter-spacing: 1px;
    font-weight: 400;
    margin-top: 5px;
  }
}
.uploadComplete {
  height: 85px;
  .up-model {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    font-weight: bold;
    padding: 0 20px;
    > div {
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: row;
      > div {
        text-align: left;
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        margin-left: 20px;
        > p {
          color: #666666;
          font-weight: 400;
        }
      }
      > p {
        display: flex;
        justify-content: center;
        align-content: center;

        img {
          width: 65px;
          height: 54px;
          margin-bottom: 0px;
        }
      }
    }
    /deep/ .ant-btn {
      margin-top: 0px !important;
    }
  }
}
.file-list {
  margin-top: 30px;
  // height: calc(100vh - 480px);
  overflow-y: auto;
  .file-item {
    border: dashed 1px #d9d9d9;
    padding: 10px 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    border-radius: 4px;

    &:hover {
      .file-size,
      .file-name {
        color: #888 !important;
      }
    }

    // 添加进度条背景
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: #f0f0f0;
      width: var(--progress, 0%);
      transition: width 0.3s ease;
      z-index: 0;
    }

    // 当进度100%时移除背景
    &[data-progress='100']::before {
      display: none;
    }

    .file-icon {
      position: relative;
      z-index: 1;
      img {
        width: 20px;
        height: auto;
      }
      margin-right: 15px;
    }
    .file-name {
      position: relative;
      z-index: 1;
      width: 90%;
      font-size: 14px;
      color: #000000;
    }
    .file-size {
      position: relative;
      z-index: 1;
      width: 100px;
      font-size: 12px;
      color: #aaa;
    }
    // 添加进度显示
    .file-progress {
      position: relative;
      z-index: 1;
      width: 80px;
      font-size: 14px;
      color: #000000;
      text-align: right;
      &::after {
        content: '%';
      }
    }
    position: relative;
    &:hover {
      .file-actions {
        display: block;
      }
    }
    .file-actions {
      display: none;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      .ant-btn {
        padding: 0 5px;
      }
    }
  }
}

.duplicate-modal-content {
  .duplicate-warning {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .duplicate-file-list {
    max-height: 200px;
    overflow-y: auto;
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 10px;

    .duplicate-file-item {
      padding: 8px;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      align-items: center;

      &:last-child {
        border-bottom: none;
      }
    }
  }
}

/* 为重复文件添加样式 */
.file-list {
  .file-item {
    &.duplicate {
      border-color: #faad14;
      background-color: rgba(250, 173, 20, 0.05);

      .file-name {
        color: #fa8c16;
      }
    }
  }
}
</style>
